var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104.91 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.1,34.88h0s-30.87-4.49-30.87-4.49L56.42,2.46c-.77-1.57-2.28-2.46-4.15-2.46h0c-1.19,0-2.9.64-3.78,2.45l-13.82,27.93-30.86,4.49c-1.71.25-3.05,1.38-3.58,3.02-.53,1.64-.11,3.33,1.12,4.53l22.34,21.54-5.28,30.88c-.23,1.3.11,2.56.94,3.55,1.33,1.58,3.65,2.08,5.49,1.1l27.62-14.48,27.61,14.49c1.85.97,4.17.47,5.49-1.1.83-.99,1.17-2.25.95-3.56l-5.28-30.69,22.34-21.54c1.24-1.27,1.67-3.06,1.1-4.76-.55-1.62-1.88-2.73-3.56-2.97ZM75.65,61.75c-.28.28-.41.66-.34,1.05h0s5.27,30.64,5.27,30.64l-27.59-14.47c-.34-.18-.75-.18-1.09,0l-27.57,14.47,5.27-30.64c.04-.22-.09-.66-.45-1.15L6.97,40.07l30.82-4.48c.37-.06.7-.29.87-.64l13.8-27.9,13.79,27.89c.17.35.5.59.88.64l30.82,4.48-22.3,21.69Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1230c10648f73b6c02a0272dbd29e192.svg";
export { ForwardRef as ReactComponent };